// @ts-nocheck

import { throttleToAnimationFrame } from './utils/utils'
import wixBgImageWrapper from './elements/wixBgImage/wixBgImage'
import wixBgMediaWrapper from './elements/wixBgMedia/wixBgMedia'
import wixElementWrapper from './elements/wixElement'
import wixIframeWrapper from './elements/wixIframe/wixIframe'
import wixImageWrapper from './elements/wixImage/wixImage'
import wixVideoWrapper from './elements/wixVideo/wixVideo'
import nativeShim from './shims/native-shim'
import { initResizeService } from './utils/initResizeService'

function init(services, contextWindow = window) {
	nativeShim(contextWindow)

	const windowResizeService = {
		registry: new Set(),
		observe(element) {
			windowResizeService.registry.add(element)
		},
		unobserve(element) {
			windowResizeService.registry.delete(element)
		},
	}

	services.windowResizeService.init(
		throttleToAnimationFrame(() => windowResizeService.registry.forEach((element) => element.reLayout())),
		contextWindow
	)

	const resizeService = initResizeService()

	const defineCustomElement = (elementName, elementClass) => {
		if (contextWindow.customElements.get(elementName) === undefined) {
			contextWindow.customElements.define(elementName, elementClass)
		}
	}

	const WixElement = wixElementWrapper({ resizeService }, contextWindow)
	defineCustomElement('wix-element', WixElement)

	const defineWixImage = (externalServices, environmentConsts) => {
		const WixImage = wixImageWrapper(WixElement, externalServices, environmentConsts, contextWindow)
		defineCustomElement('wix-image', WixImage)
	}

	const defineWixBgImage = (externalServices, environmentConsts) => {
		const WixBgImage = wixBgImageWrapper(WixElement, externalServices, environmentConsts, contextWindow)
		defineCustomElement('wix-bg-image', WixBgImage)
	}

	const defineWixBgMedia = (externalServices) => {
		const WixBgMedia = wixBgMediaWrapper(WixElement, { windowResizeService, ...externalServices }, contextWindow)
		defineCustomElement('wix-bg-media', WixBgMedia)
	}

	const defineWixVideo = (externalServices, environmentConsts) => {
		const WixVideo = wixVideoWrapper(WixElement, externalServices, environmentConsts, contextWindow)
		defineCustomElement('wix-video', WixVideo)
	}

	const defineWixIframe = () => {
		const WixIframe = wixIframeWrapper(WixElement)
		defineCustomElement('wix-iframe', WixIframe)
	}

	return {
		contextWindow,
		defineWixImage,
		defineWixBgImage,
		defineWixBgMedia,
		defineWixVideo,
		defineWixIframe,
	}
}

export default {
	init,
}
